import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { JsonDataService } from './json-data.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WordingService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private jsonDataService: JsonDataService) {}

  getWordings(): Observable<any[]> {
    switch (environment.autoClub) {
      case 'W2C':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.w2cWordings));
      case 'RACV':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.racvWordings));
      case 'AANT':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.aantWordings));
      case 'RACQ':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.racqWordings));
      case 'RACT':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.ractWordings));
      case 'RAC':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.racWordings));
      case 'RAA':
        return this.jsonDataService
          .getWordingJsonData()
          .pipe(map((validation) => validation.raaWordings));
      default:
        return this.jsonDataService.getWordingJsonData();
    }
  }

  getInformationTemplateWordings(): Observable<any[]> {
    switch (environment.autoClub) {
      case 'W2C':
        return this.jsonDataService
          .getInformationTepmlateJsonData()
          .pipe(map((validation) => validation.w2cInformation));
      default:
        return this.jsonDataService.getInformationTepmlateJsonData();
    }
  }
}
